<template>
  <div>
    <div class="row mt-2">
      <div class="col-12">
        <h5 style="border-bottom: 1px solid #ddd; padding-bottom: 15px;">{{ title }}</h5>
      </div>

      <!-- Loop through items and render inputs -->
      <div class="col-12" v-for="(item, index) in items" :key="index">
        <BaseInput v-model="item.id"
                   hidden="hidden"/>

        <!-- RESOURCES -->
        <div class="row">
          <div class="col-12 mt-3 mb-1" style="font-weight: bold; font-size: 18px">Ressourcen</div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <SelectVue
                v-model="item.followingResources"
                :options="resourceDropdown"
                label="Der Coachee bringt folgende Ressourcen mit:"
                :is-clear="true"
                placeholder="Wert auswählen"/>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-12">
            <SelectVue
                v-model="item.followingResourcesWasActivated"
                :options="resourceDropdown"
                label="Im Verlauf des Coachings wurde folgende Ressource aktiviert/erarbeitet:"
                :is-clear="true"
                placeholder="Wert auswählen"/>
          </div>
        </div>

        <!-- PROFESSIONAL SKILLS -->
        <div class="row">
          <div class="col-12 mt-3 mb-1" style="font-weight: bold; font-size: 18px">Fachliche Kompetenzen</div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <SelectVue
                v-model="item.professionalSkills"
                :options="professionalSkillsDropdown"
                label="Der Coachee bringt folgende fachliche Kompetenzen mit:"
                :is-clear="true"
                placeholder="Wert auswählen"/>
          </div>
        </div>

        <!-- PROFESSIONAL COMPETENCIES -->
        <div class="row">
          <div class="col-12 mt-3 mb-1" style="font-weight: bold; font-size: 18px">Berufliche Kompetenzen</div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <SelectVue
                v-model="item.existingProfessionalCompetencies"
                :options="competenciesDropdown"
                label="Zu den vorhandenen beruflichen Kompetenzen gehört:"
                :is-clear="true"
                placeholder="Wert auswählen"/>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <SelectVue
                v-model="item.acquiredAdditionalSkills"
                :options="competenciesDropdown"
                label="Im Rahmen des Coachingprozesses hat der Coachee weitere Kompetenzen erworben, wie z.B."
                :is-clear="true"
                placeholder="Wert auswählen"/>
          </div>
        </div>

        <!-- EXISTING ACTION SKILLS  -->
        <div class="row">
          <div class="col-12 mt-3 mb-1" style="font-weight: bold; font-size: 18px">Handlungskompetenzen</div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <SelectVue
                v-model="item.existingActionSkills"
                :options="actionSkillsDropdown"
                label="Zu vorhandener Handlungskompetenz des Coachees zählt …"
                :is-clear="true"
                placeholder="Wert auswählen"/>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <SelectVue
                v-model="item.acquiredAdditionalActionSkills"
                :options="actionSkillsDropdown"
                label="Im Rahmen des Coachingprozesses hat der Coachee weitere Kompetenzen erworben, wie z.B."
                :is-clear="true"
                placeholder="Wert auswählen"/>
          </div>
        </div>

        <!-- COMMUNICATIVE SKILLS  -->
        <div class="row">
          <div class="col-12 mt-3 mb-1" style="font-weight: bold; font-size: 18px">Kommunikative Kompetenzen</div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <SelectVue
                v-model="item.existingCommunicativeSkills"
                :options="communicativeSkillsDropdown"
                label="Die vorhandene kommunikative Kompetenz wurde deutlich durch …"
                :is-clear="true"
                placeholder="Wert auswählen"/>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <SelectVue
                v-model="item.acquiredAdditionalCommunicativeSkills"
                :options="communicativeSkillsDropdown"
                label="Im Rahmen des Coachingprozesses hat der Coachee seine Kompetenzen erweitert durch"
                :is-clear="true"
                placeholder="Wert auswählen"/>
          </div>
        </div>

        <!-- EMOTIONAL SKILLS  -->
        <div class="row">
          <div class="col-12 mt-3 mb-1" style="font-weight: bold; font-size: 18px">Emotionale Kompetenzen</div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <SelectVue
                v-model="item.existingEmotionalSkills"
                :options="emotionalSkillsDropdown"
                label="Der Teilnehmende ist …"
                :is-clear="true"
                placeholder="Wert auswählen"/>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <SelectVue
                v-model="item.acquiredAdditionalEmotionalSkills"
                :options="emotionalSkillsDropdown"
                label="Im Coachingprozess hat der Teilnehmende seine Kompetenzen erweitert und ist jetzt"
                :is-clear="true"
                placeholder="Wert auswählen"/>
          </div>
        </div>

        <!-- SOCIALS SKILLS  -->
        <div class="row mb-3 pb-2">
          <div class="col-12 mt-3 mb-1" style="font-weight: bold; font-size: 18px">Soziale Kompetenzen</div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <SelectVue
                v-model="item.existingSocialSkills"
                :options="socialSkillsDropdown"
                label="Der Teilnehmende zeigte …"
                :is-clear="true"
                placeholder="Wert auswählen"/>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <SelectVue
                v-model="item.acquiredAdditionalSocialSkills"
                :options="socialSkillsDropdown"
                label="Im Rahmen des Coachingprozesses hat der Teilnehmende seine Kompetenzen erweitert mit"
                :is-clear="true"
                placeholder="Wert auswählen"/>
          </div>
          <div class="col-12 mt-3">
            <TextEditor
                v-model="item.description"
                @update:model-value="item.description = $event"
                :inputStyle="{ height: '200px' }"
                label="Beschreibung"/>
          </div>
        </div>

        <!-- Delete Button -->
        <button
            class="btn btn-danger mb-5 mt-2"
            v-if="items && items.length > 0"
            @click="deleteItem(index)">
          Löschen
        </button>
        <div class="col-12" style="border-bottom: 1px solid #D8D8D8"></div>
      </div>

      <div class="col-12 mt-4">
        <div class="row">
          <div class="col-12">
            <!-- Add Button -->
            <div class="text-right">
              <button type="button" class="btn btn-primary" @click="addItem">
                +
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import BaseInput from '@/components/base/BaseInput.vue';
import SelectVue from '@/components/SelectVue.vue';
import TextEditor from '@/components/TextEditor.vue';
import { defineEmits, defineProps, ref } from 'vue';

// Props
defineProps({
  title: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  resourceDropdown: {
    type: Array,
    default: () => [],
    required: true,
  },
  professionalSkillsDropdown: {
    type: Array,
    default: () => [],
    required: true,
  },
  competenciesDropdown: {
    type: Array,
    default: () => [],
    required: true,
  },
  actionSkillsDropdown: {
    type: Array,
    default: () => [],
    required: true,
  },
  communicativeSkillsDropdown: {
    type: Array,
    default: () => [],
    required: true,
  },
  emotionalSkillsDropdown: {
    type: Array,
    default: () => [],
    required: true,
  },
  socialSkillsDropdown: {
    type: Array,
    default: () => [],
    required: true,
  },
});


// Emits
const emit = defineEmits([ 'addItem', 'deleteItem' ]);

// Helper Methods
const addItem    = () => {
  emit('addItem', {
    followingResources: '',
    followingResourcesWasActivated: '',
    professionalSkills: '',
    existingProfessionalCompetencies: '',
    acquiredAdditionalSkills: '',
    existingActionSkills: '',
    acquiredAdditionalActionSkills: '',
    existingCommunicativeSkills: '',
    acquiredAdditionalCommunicativeSkills: '',
    existingEmotionalSkills: '',
    acquiredAdditionalEmotionalSkills: '',
    existingSocialSkills: '',
    acquiredAdditionalSocialSkills: '',
  });
};
const deleteItem = (index) => {
  emit('deleteItem', index);
};
</script>

<style scoped>
/* Add component-specific styles here if necessary */
</style>
